import * as constants from '../irmlib/src/common/constants'

/** Field indices shared by AddActivity and LocalAddActivity form templates. */
export const ADD_ACTIVITY_FIELD_INDEX = {
  ACCOUNT_LEVEL1: 0,
  TEMPLATE_TYPE: 9,
  LINE_OF_BUSINESS: 10,
  WMS_INSTANCE: 11,
  WMS_REGION: 12,
}

export const CLEARED_TEMPLATE_RESULTS_STATE = {
  templateData: [],
  templateName: '',
  haveExistingRequest: false,
  showTable: false,
  showForm: false,
  selectedRowRequestId: 0,
  rowPassed: 0,
  errorMsg: '',
}

export const isFilledFormValue = (value) =>
  value != null && value !== '' && value !== constants.defaultSelect

export const isAddActivityGetTemplateReady = ({
  arrRefs,
  selectedAssetType,
  assetTypeOverride,
  fieldIndex = ADD_ACTIVITY_FIELD_INDEX,
}) => {
  const assetType = assetTypeOverride !== undefined ? assetTypeOverride : selectedAssetType
  const wmsInstance = arrRefs[fieldIndex.WMS_INSTANCE]?.current?.getValue()
  const accountLevel1 = arrRefs[fieldIndex.ACCOUNT_LEVEL1]?.current?.getValue()
  const templateType = arrRefs[fieldIndex.TEMPLATE_TYPE]?.current?.getValue()
  const businessType = arrRefs[fieldIndex.LINE_OF_BUSINESS]?.current?.getValue()
  const wmsRegion = arrRefs[fieldIndex.WMS_REGION]?.current?.getValue()

  return (
    isFilledFormValue(wmsInstance) &&
    isFilledFormValue(accountLevel1) &&
    isFilledFormValue(assetType) &&
    isFilledFormValue(templateType) &&
    isFilledFormValue(businessType) &&
    (wmsInstance !== 'ONEIL' || isFilledFormValue(wmsRegion))
  )
}
